import jaJP from './ja/messages';
import enUS from './en/messages';
import { LOCALE } from '../env';

export const locale = LOCALE;

export const chooseLocale = (_locale) => {
  switch (_locale) {
    case 'gh':
      return enUS;
    default:
      return jaJP;
  }
};
